import { ArrowUpRight } from "lucide-react";
import { ScrollReveal } from "./MaskedReveal";
import { PACKAGES } from "../data/siteData";

export const Pricing = ({ onRequest }) => (
  <section id="ceni" className="relative border-t border-[#14110D]/10 py-24" data-testid="pricing-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
      <ScrollReveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C8402A]">§ 03</p>
            <h2 className="mt-2 font-serif text-4xl uppercase tracking-tight text-[#14110D] sm:text-5xl lg:text-6xl">Цени</h2>
            <p className="mt-4 max-w-lg font-serif text-xl italic text-[#524E48]">Начини да работим заедно</p>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8C867E]">Три оферти</p>
        </div>
      </ScrollReveal>

      <div className="mt-12 grid gap-6 lg:grid-cols-3">
        {PACKAGES.map((pkg, i) => (
          <ScrollReveal key={pkg.id} delay={i * 0.12}>
            <article
              data-testid={pkg.testid}
              className={`group relative flex h-full flex-col rounded-[1.75rem] border p-8 transition-transform duration-500 hover:-translate-y-2 ${
                pkg.featured
                  ? "border-[#14110D] bg-[#14110D] text-[#F4F1EA]"
                  : "border-[#14110D]/15 bg-[#FAF8F5] text-[#14110D]"
              }`}
            >
              {pkg.featured && (
                <span className="absolute -top-3.5 right-8 rounded-full bg-[#C8402A] px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-[#F4F1EA]">
                  Най-търсен
                </span>
              )}
              <h3 className="font-serif text-2xl">{pkg.name}</h3>
              <p className="mt-5 font-serif text-5xl tracking-tight">{pkg.price}</p>
              <p className={`mt-2 font-mono text-[10px] uppercase tracking-[0.25em] ${pkg.featured ? "text-[#F4F1EA]/50" : "text-[#8C867E]"}`}>
                {pkg.per}
              </p>
              <p className={`mt-6 text-sm leading-relaxed ${pkg.featured ? "text-[#F4F1EA]/75" : "text-[#524E48]"}`}>{pkg.desc}</p>
              <ul className="mt-8 flex-1 space-y-3">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-baseline gap-3 text-sm">
                    <span className={`font-mono text-xs ${pkg.featured ? "text-[#C8402A]" : "text-[#C8402A]"}`}>—</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <button
                data-testid={`pricing-cta-${pkg.id}`}
                onClick={onRequest}
                className={`mt-9 flex items-center justify-center gap-2 rounded-full py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                  pkg.featured
                    ? "bg-[#C8402A] text-[#F4F1EA] hover:bg-[#B0341F]"
                    : "border border-[#14110D]/25 text-[#14110D] hover:bg-[#14110D] hover:text-[#F4F1EA]"
                }`}
              >
                Запитване <ArrowUpRight className="h-3.5 w-3.5" />
              </button>
            </article>
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal delay={0.2}>
        <p
          data-testid="pricing-note"
          className="mt-10 rounded-2xl border border-[#14110D]/15 bg-[#EFEBE1] px-6 py-4 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-[#524E48]"
        >
          Цените са в евро · Оферта до 24 часа след запитване
        </p>
      </ScrollReveal>
    </div>
  </section>
);
